import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, Nav, NavItem, Row, TabContent, Table, TabPane, Tooltip, NavLink, CardTitle } from "reactstrap";
import classnames from "classnames";
import { updateSubscriptionStoreRoute, userSubscriptionViewDetailsApi } from "./_requests";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useToast } from "../../Components/Common/ToastContext";
import { toast, ToastContainer } from "react-toastify";
import OrderStoreUpdate from "../../pages/Orders/OrderStoreUpdate";
import { listStore } from "../../pages/Route/_requests";
import { listRoute } from "../../pages/Route/_requests";
import OrderRouteUpdate from "../../pages/Orders/OrderRouteUpdate";
import { useParams } from "react-router-dom";
import UserPlanSubscriptionHistory from "./UserPlanSubscriptionHistory";
import { formatDate } from "../../helpers/FunctionHelpers";

const UserSubscriptionView = () => {
    const { id } = useParams();
    const [selectedRoute, setSelectedRoute] = useState("");
    const [selectedStore, setSelectedStore] = useState("");
    const [isRouteModalOpen, setIsRouteModalOpen] = useState(false);
    const [isStoreModalOpen, setIsStoreModalOpen] = useState(false);
    const [ordersListRoute, setRoute] = useState<any>([]);
    const [ordersListStore, setStore] = useState<any>([]);
    const [selectedSubscriptionId, setSelectedSubscriptionId] = useState<number | null>(null);
    const { showToast, toaster, clearToast } = useToast();
    const [activeTab, setActiveTab] = useState("1");

    const [isUpgrading, setIsUpgrading] = useState(false);
    const [isDowngrading, setIsDowngrading] = useState(false);

    // Add these functions
    const handleUpgrade = async () => {
        setIsUpgrading(true);
        try {
            // Call your upgrade API here
            // await upgradeSubscriptionPlan(id);
            showToast("Plan upgraded successfully!", true);
            fetchPlan(); // Refresh data
        } catch (error) {
            showToast("Failed to upgrade plan", false);
        } finally {
            setIsUpgrading(false);
        }
    };

    const handleDowngrade = async () => {
        setIsDowngrading(true);
        try {
            // Call your downgrade API here
            // await downgradeSubscriptionPlan(id);
            showToast("Plan downgraded successfully!", true);
            fetchPlan(); // Refresh data
        } catch (error) {
            showToast("Failed to downgrade plan", false);
        } finally {
            setIsDowngrading(false);
        }
    };

    const toggleTab = (tab: string) => setActiveTab(tab);
    useEffect(() => {
        if (toaster?.message) {
            toast[toaster.status ? "success" : "error"](toaster.message, { autoClose: 3000 });
            clearToast();
        }
    }, [toaster, clearToast]);
    useEffect(() => {
        listStore().then((res: any) => {
            setStore(res.data);
        });

        listRoute().then((res: any) => {
            setRoute(res.data);
        });
    }, []);
    const [plan, setPlan] = useState<{
        id: number;
        type_name: string;
        subscription: { name: string; image: string; description: string, max_cancel_validity_days: number };
        payment_id?: string;
        payment_status: string;
        start_date: string;
        slot_type_name: string;
        remaining_days_plan: number;
        end_date?: string;
        user: { name: string; email: string; mobile_number: string };
        addressbook: {
            address: string;
            city: string;
            state: string;
            address_type: string;
            mobile_number: string;
            postal_code: string | number;
            latitude?: number;
            longitude?: number;
        };
        details: Array<{
            id: number;
            product: { name: string; icon: string };
            variant: { name: string };
            variant_value: string;
            // slot_type_name: string;
            validity: number;
            validity_type: string;
        }>;
        store?: { name: string };
        route?: { name: string };
    } | null>(null);
    const fetchPlan = () => {
        userSubscriptionViewDetailsApi(id).then((res) => {
            setPlan(res.data);
        });
    };
    useEffect(() => {
        fetchPlan();
    }, [id]);
    console.log("plan user subscription page view plan state list", plan)
    useEffect(() => {
        userSubscriptionViewDetailsApi(id).then((res) => {
            setPlan(res.data);
        });
    }, [id]);

    if (!plan) {
        return (
            <Container className="py-5">
                <h4 className="text-center">No data found</h4>
            </Container>
        );
    }
    const toggleRouteModal = (subscriptionId?: number) => {
        if (subscriptionId !== undefined) {
            setSelectedSubscriptionId(subscriptionId); // Set selected order ID
            console.log("Selected Order ID:", subscriptionId);
        }
        setIsRouteModalOpen((prev) => !prev); // Toggle modal open/close
    };

    const toggleStoreModal = (subscriptionId?: number) => {
        if (subscriptionId !== undefined) {
            setSelectedSubscriptionId(subscriptionId); // Set selected order ID
            console.log("Selected Order ID:", subscriptionId);
        }
        setIsStoreModalOpen((prev) => !prev); // Toggle modal open/close
    };
    const handleStoreUpdate = async () => {
        const data = { subscription_id: selectedSubscriptionId, store_id: selectedStore };
        const res: any = await updateSubscriptionStoreRoute(data);
        if (res.status === true) {
            showToast(res.message, res.status);
            fetchPlan();
        } else {
            showToast(res.message, res.status);
        }
        toggleStoreModal();
    };

    const handleRouteUpdate = async () => {
        const data = { subscription_id: selectedSubscriptionId, route_id: selectedRoute };
        const res: any = await updateSubscriptionStoreRoute(data);
        if (res.status === true) {
            showToast(res.message, res.status);
            fetchPlan();
        } else {
            showToast(res.message, res.status);
        }
        toggleRouteModal();
    };

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="🎯 Subscription Details" pageTitle="Paal Dappa" />
                <ToastContainer closeButton={false} limit={1} />
                {/* Tabs */}
                <Nav tabs className="nav-tabs-custom me-3 text-info">
                    <NavItem>
                        <NavLink
                            href="#"
                            className={classnames({ active: activeTab === "1" })}
                            onClick={() => toggleTab("1")}
                        >
                            Overview
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            href="#"
                            className={classnames({ active: activeTab === "2" })}
                            onClick={() => toggleTab("2")}
                        >
                            Delivery History
                        </NavLink>
                    </NavItem>
                </Nav>

                <TabContent activeTab={activeTab} className="mt-4">
                    {/* Overview Tab */}
                    <TabPane tabId="1">
                        <Row className="g-2">
                            {/* Store Card */}
                            <Col md={6} className="mx-auto mb-4">
                                <Card className="shadow border-0 position-relative h-75" style={{ background: "#e9e9ef" }}>
                                    <Button
                                        color="primary"
                                        size="sm"
                                        className="position-absolute"
                                        style={{ top: "10px", right: "10px" }}
                                        onClick={() => toggleStoreModal(id ? Number(id) : undefined)}
                                    >
                                        <i className="ri-edit-2-line me-1"></i> Update
                                    </Button>
                                    <CardBody className="cursor-pointer" onClick={() => toggleStoreModal(id ? Number(id) : undefined)}>
                                        <h5 className="text-primary mb-2">Store Update</h5>
                                        <br />
                                        <p>
                                            <b>Name:</b> {plan?.store?.name || "-"}
                                        </p>
                                    </CardBody>
                                </Card>
                            </Col>

                            <OrderStoreUpdate
                                isOpen={isStoreModalOpen}
                                toggle={toggleStoreModal}
                                selectedStore={selectedStore}
                                setSelectedStore={setSelectedStore}
                                ordersListStore={ordersListStore}
                                handleStoreUpdate={handleStoreUpdate}
                            />

                            {/* Route Card */}
                            <Col md={6} className="mx-auto mb-4 ">
                                <Card className="shadow border-0 position-relative h-75" style={{ background: "#e9e9ef" }}>
                                    <Button
                                        color="primary"
                                        size="sm"
                                        className="position-absolute"
                                        style={{ top: "10px", right: "10px" }}
                                        onClick={() => toggleRouteModal(id ? Number(id) : undefined)}
                                    >
                                        <i className="ri-edit-2-line me-1"></i> Update
                                    </Button>
                                    <CardBody>
                                        <h5 className="text-primary ">Route Update</h5>
                                        <br />
                                        <p>
                                            <b>Type:</b> {plan?.route?.name || "-"}
                                        </p>
                                    </CardBody>
                                </Card>
                            </Col>

                            <OrderRouteUpdate
                                isOpen={isRouteModalOpen}
                                toggle={toggleRouteModal}
                                selectedRoute={selectedRoute}
                                setSelectedRoute={setSelectedRoute}
                                ordersListRoute={ordersListRoute}
                                handleRouteUpdate={handleRouteUpdate}
                            />

                            {/* Subscription Card */}
                            <Col lg={6} className="mx-auto mb-4 ">
                                <Card className="shadow border-0 h-100">
                                    {/* {plan.subscription?.image && (
                                <CardImg
                                    top
                                    src={plan.subscription.image}
                                    alt={plan.subscription.name}
                                    className="img-fluid w-100"
                                    style={{ maxHeight: "300px", objectFit: "cover" }}
                                />
                            )} */}
                                    <CardBody>
                                        <CardTitle tag="h4" className="text-info mb-3">{plan?.subscription?.name}</CardTitle>

                                        <h5 className="text-secondary mb-2">Plan Details</h5>
                                        <p><b>Type:</b> {plan?.type_name}</p>
                                        <p><b>Payment ID:</b> {plan?.payment_id || "N/A"} ({plan?.payment_status})</p>
                                        <p><b>Start Date:</b> {formatDate(plan.start_date)}</p>
                                        <p><b>End Date:</b> {plan?.end_date ? formatDate(plan?.end_date) : "N/A"}</p>
                                        <p><b>Slot Type:</b> {plan?.slot_type_name || "N/A"}</p>
                                    </CardBody>
                                </Card>
                            </Col>

                            {/* Product Details */}
                            <Col lg={6} className="mx-auto mb-4 ">
                                <Card className="shadow border-0 h-100">
                                    <CardBody>
                                        <h5 className="text-warning mb-3">Product Details</h5>
                                        {plan?.details?.map((detail) => (
                                            <Card key={detail?.id} className="mb-3 p-3 shadow-sm border-0 bg-white">
                                                <Row className="g-3 align-items-center">
                                                    {/* <Col xs={12} md={3}>
                                                <img
                                                    src={detail.product.icon}
                                                    alt={detail.product.name}
                                                    className="img-fluid rounded w-100"
                                                />
                                            </Col> */}
                                                    <Col xs={12} md={12}>
                                                        <CardTitle tag="h4" className="text-info mb-3">
                                                            {plan?.subscription?.name} ({plan?.type_name})
                                                        </CardTitle>
                                                        <p><b>Product:</b> {detail?.product?.name}</p>
                                                        <p><b>Variant:</b> {detail?.variant_value} {detail?.variant?.name}</p>
                                                        <p><b>Validity:</b> {detail?.validity} Days</p>
                                                        <p><b>Remaining days:</b> {plan?.remaining_days_plan} Days</p>
                                                        <p><b>Maximum validity days:</b> {plan?.subscription?.max_cancel_validity_days} Days</p>
                                                    </Col>

                                                    {/* Add these buttons at the bottom */}
                                                    {/* <div className="d-flex gap-2 mt-3">
                                                        <Button
                                                            color="success"
                                                            onClick={handleUpgrade}
                                                            disabled={isUpgrading}
                                                        >
                                                            {isUpgrading ? 'Processing...' : 'Upgrade Plan'}
                                                        </Button>
                                                        <Button
                                                            color="warning"
                                                            onClick={handleDowngrade}
                                                            disabled={isDowngrading}
                                                        >
                                                            {isDowngrading ? 'Processing...' : 'Downgrade Plan'}
                                                        </Button>
                                                    </div> */}
                                                </Row>
                                            </Card>
                                        ))}
                                    </CardBody>
                                </Card>
                            </Col>

                            {/* User Details */}
                            <Col lg={6} className="mx-auto mb-4">
                                <Card className="shadow border-0 h-100">
                                    <CardBody>
                                        <CardTitle tag="h4" className="text-info mb-3">
                                            {plan?.subscription?.name}
                                        </CardTitle>

                                        <h5 className="text-secondary mb-2">Plan Details</h5>
                                        <p><b>Type:</b> {plan?.type_name}</p>
                                        <p><b>Payment ID:</b> {plan?.payment_id || "N/A"} ({plan?.payment_status})</p>
                                        <p><b>Start Date:</b> {formatDate(plan.start_date)}</p>
                                        <p><b>End Date:</b> {plan?.end_date ? formatDate(plan?.end_date) : "N/A"}</p>
                                        <p><b>Slot Type:</b> {plan?.slot_type_name || "N/A"}</p>


                                    </CardBody>
                                </Card>
                            </Col>

                            {/* Address */}
                            <Col lg={6} className="mx-auto mb-4">
                                <Card className="shadow border-0 h-100">
                                    <CardBody>
                                        <h5 className="text-muted mb-3">Address</h5>
                                        <p><b>Type:</b> {plan?.addressbook?.address_type}</p>
                                        <p>{plan?.addressbook.address}, {plan?.addressbook?.city}, {plan?.addressbook?.state} - {plan?.addressbook?.postal_code}</p>
                                        {(plan?.addressbook?.latitude || plan?.addressbook?.longitude) && (
                                            <p className="text-info">
                                                <i className="ri-map-pin-fill me-1"></i>
                                                <b>Lat:</b> {plan.addressbook.latitude}, <b>Long:</b> {plan.addressbook.longitude}
                                            </p>
                                        )}
                                        <p><b>Mobile:</b> {plan?.addressbook?.mobile_number}</p>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId="2">

                        <UserPlanSubscriptionHistory />
                    </TabPane>
                </TabContent>
            </Container>
        </div>
    );
};

export default UserSubscriptionView;
